import { lazyInit } from '@mail-core/std/fn/lazy/lazyInit';

export const lazyKotlett = lazyInit(() =>
    Promise.all([
        import(/* webpackChunkName: "kotlett" */ '@mail/kotlett'),
        import(/* webpackChunkName: "kotlett-feature-bundle" */ '@mail/kotlett-feature-bundle'),
    ]).then(([kotletModule, featuresModule]) => {
        const { WebKotlett } = kotletModule;
        const { runtime } = featuresModule;

        return { WebKotlett, runtime };
    })
);
